'use strict';
/**
 * A service to get all of the available activities.
 */

angular.module('msActivityServices').service('feedbackSvc', ['httpSvc', function (httpSvc) {
  function activityFeedback(activity, feedback) {
    return httpSvc.post('/apiproxy/user/feedback/activities/' + activity.url, feedback || 50);
  }

  return {
    activityFeedback: activityFeedback
  };
}]);